var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"attention"},[_vm._v("※20文字以内")]),_c('v-text-field',{staticClass:"input-exam ma-0",attrs:{"color":"secondary","rules":_vm.rules,"outlined":"","dense":""},model:{value:(_vm.selectedTitle),callback:function ($$v) {_vm.selectedTitle=$$v},expression:"selectedTitle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }